import { render, staticRenderFns } from "./mould_tonage_change_log.vue?vue&type=template&id=f56d688c&scoped=true&"
import script from "./mould_tonage_change_log.vue?vue&type=script&lang=js&"
export * from "./mould_tonage_change_log.vue?vue&type=script&lang=js&"
import style0 from "./mould_tonage_change_log.vue?vue&type=style&index=0&id=f56d688c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56d688c",
  null
  
)

export default component.exports